import { useState } from "react";
import classNames from "classnames";


import { LocationIcon, MoreIcon } from "../../AscIcons";

import styles from "./AscAdminJobCard.module.scss";
import AscHeading from "../../AscTypography/AscHeading/AscHeading";
import AscAdminAction from "../../AscAdminAction/AscAdminAction";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";

interface JobsDataTypes {
  id: string,
  title: string,
  country: string,
  city: string,
  jobCategory: string,
  minSalary: number,
  maxSalary: number
}

interface AscAdminJobCardProps extends JobsDataTypes {
  className?: string,
  onEdit?: () => void;
  onRemove?: () => void;
}

export default function AscAdminJobCardCard({
  className,
  title,
  country,
  city,
  jobCategory,
  minSalary,
  maxSalary,
  onEdit,
  onRemove
}: AscAdminJobCardProps) {
  const [showAction, setShowAction] = useState<boolean>(false);

  return (
    <div
      data-testid="asc-company-card"
      className={classNames(styles.ground, className)}
    >

      <div className={styles.infoGround}>
        <div className={styles.topSection}>
          <AscHeading className={styles.companyName} level={6}>
            {title}
          </AscHeading>
          <MoreIcon 
            className={styles.icon}
            onClick={() => setShowAction(!showAction)}
          />

          {showAction && (
            <AscAdminAction
              option1={"Edit"}
              option2={"Remove"}
              clickOption1={onEdit}
              clickOption2={onRemove}
              className={styles.actionBar}
            />
          )}
        </div>

        <div className={styles.middleSection}>
          <AscParagraph className={styles.text}>Category: {jobCategory}</AscParagraph>
          <AscParagraph className={styles.text}>Salary: {minSalary} - {maxSalary}</AscParagraph>
          <div className={styles.location}>
            <LocationIcon />
            <AscParagraph className={styles.text}>{country}, {city}</AscParagraph>
          </div>
        </div>

      </div>
    </div>
  );
}
